var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',[_vm._v("5、下列不需要进行会计处理的业务有（　）。"),_c('br')]),_vm._v("A、用盈余公积转增资本"),_c('br'),_c('br'),_vm._v("B、用资本公积转增资本"),_c('br'),_c('br'),_vm._v("C、用税前利润补亏"),_c('br'),_c('br'),_vm._v("D、用税后利润补亏"),_c('br'),_c('br'),_vm._v("E、发放股票股利 ")])
}]

export { render, staticRenderFns }